// Bildet aus dem Datenstand dieselben Daten, die die Datenbankfunktion moodle_stundenplan liefert
// (für Vorschau und statische Momentaufnahme in der Planungsoberfläche).
import type { Stand, Id } from '../daten/typen';
import type { MoodleDaten, MoodleTermin } from './baustein';
import { knotenFachbereich } from '../daten/regeln';

export function moodleDaten(stand: Stand, kursId: Id): MoodleDaten | null {
  const k = stand.kurse.find(x => x.id === kursId);
  if (!k) return null;
  const jetzt = new Date();
  const planstand = `${String(jetzt.getDate()).padStart(2, '0')}.${String(jetzt.getMonth() + 1).padStart(2, '0')}.${jetzt.getFullYear()} ${String(jetzt.getHours()).padStart(2, '0')}:${String(jetzt.getMinutes()).padStart(2, '0')}`;
  const termine: MoodleTermin[] = stand.einsaetze
    .filter(e => e.kurs_id === kursId && (e.status === 'freigegeben' || (e.status === 'entfaellt' && e.freigegeben_am)))
    .sort((a, b) => (a.datum + a.beginn).localeCompare(b.datum + b.beginn))
    .map(e => {
      const kk = stand.kursKnoten.find(x => x.id === e.kurs_knoten_id);
      const p = kk?.parent_id ? stand.kursKnoten.find(x => x.id === kk.parent_id) : undefined;
      const fb = stand.fachbereiche.find(f => f.id === knotenFachbereich(stand, e.kurs_knoten_id));
      const d = stand.dozenten.find(x => x.id === e.dozent_id);
      return {
        datum: e.datum, beginn: e.beginn.slice(0, 5), ende: e.ende.slice(0, 5), ue: e.ue, form: e.form,
        status: e.status as 'freigegeben' | 'entfaellt', hinweis: e.hinweis, thema: kk?.bezeichnung ?? null, oberthema: p?.bezeichnung ?? null,
        fachbereich: fb ? { name: fb.bezeichnung, kuerzel: fb.kuerzel, farbe: fb.farbe } : null,
        dozent: d ? { kuerzel: d.kuerzel, name: [d.anrede, d.vorname.charAt(0) + '.', d.nachname].filter(Boolean).join(' '), farbe: d.farbe } : null,
        raum: stand.raeume.find(r => r.id === e.raum_id)?.bezeichnung ?? null,
      };
    });
  return {
    kurs: { kennung: k.kennung, bezeichnung: k.bezeichnung, beginn: k.beginn, ende: k.ende, form: k.standard_form,
      standort: stand.standorte.find(s => s.id === k.standort_id)?.bezeichnung ?? null, links: k.moodle_links ?? [], planstand },
    mandant: { name: stand.mandant.name, einheit: stand.mandant.einheit, logo: stand.mandant.logo_url, farbe: stand.mandant.farbe_primaer },
    zeitfenster: stand.zeitfenster.filter(z => z.zeitraster_id === k.zeitraster_id).sort((a, b) => a.sortierung - b.sortierung)
      .map(z => ({ bezeichnung: z.bezeichnung, beginn: z.beginn.slice(0, 5), ende: z.ende.slice(0, 5) })),
    feiertage: stand.kalender.filter(t => t.datum >= k.beginn && t.datum <= k.ende && (!t.standort_id || t.standort_id === k.standort_id))
      .map(t => ({ datum: t.datum, bezeichnung: t.bezeichnung })),
    termine,
  };
}
